import { Fab, useTheme, alpha, Tooltip } from '@mui/material';
import { HelpCircle } from 'lucide-react';
import { hasActiveSubscriptionPlans, useSubscriptionDetailsStore } from '@zeta-core';

interface FloatingSupportButtonProps {
  onClick: () => void;
}

const FloatingSupportButton = ({ onClick }: FloatingSupportButtonProps) => {
  const theme = useTheme();
  const currentSubscription = useSubscriptionDetailsStore((state) => state.subscription);
  const isSubscriptionActive = hasActiveSubscriptionPlans(currentSubscription);

  if (!isSubscriptionActive || currentSubscription?.cancelStatus === 'SUSPENDEDTOCANCEL') {
    return null;
  }

  return (
    <Tooltip title="Need Help?" placement="left">
      <Fab
        onClick={onClick}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          width: 56,
          height: 56,
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          color: 'white',
          boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.4)}`,
          transition: 'all 0.3s ease-in-out',
          zIndex: 1000,
          '&:hover': {
            transform: 'scale(1.1)',
            boxShadow: `0 6px 30px ${alpha(theme.palette.primary.main, 0.6)}`,
            background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
          },
          '&:active': {
            transform: 'scale(0.95)',
          },
        }}
      >
        <HelpCircle size={28} />
      </Fab>
    </Tooltip>
  );
};

export default FloatingSupportButton;
